import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { labQKeys } from "@hooks/queries/lab/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  labId: string;
  fileName: string;
  patientId: string;
}

export const useDeleteLabFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ labId, fileName }: MutationProps) => {
      return api.delete(`lab/${labId}/file/${fileName}`);
    },
    onSuccess: (res, variables) => {
      // console.log("File deleted res", res.data);
      showSuccessNotification({
        title: "success",
        message: "delete-lab-file-success",
      });
      if (!res.data.count) {
        queryClient.invalidateQueries({
          queryKey: labQKeys.patient(variables.patientId),
        });
      }
    },

    onError: res => {
      console.error("[From Delete Lab File]", res);

      handleErrors(res, "mutation");
    },
  });
};
